import { useMediaQuery, useTheme } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import { LinkKeepUTM } from "../../shared/components/LinkKeepUTM";
import { NewMenu } from "../../shared/components/NewMenu";
import { FruitionLogo } from "../../shared/icons";
import { drawerMenuStyles } from "./drawer-menu.styles";
import { MyResources } from "./my-resourcers.component";
import { ProfileScreen } from "./profile-screen";

export type SCREEN = "default" | "profile" | "myResources";

interface DrawerMenuProps {
  mobileOpen: boolean;
  setScreen: (screen: string[]) => void;
  onClickMenuOption: () => void;
  screen: string[];
}

export const DrawerMenu = (props: DrawerMenuProps) => {
  const { mobileOpen, setScreen, onClickMenuOption, screen } = props;
  const classes = drawerMenuStyles();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  const onBack = () => {
    screen.pop();
    setScreen([...screen]);
  };

  const renderScreen = () => {
    const currentPage = screen[screen.length - 1];
    if (currentPage === "profile") {
      return (
        <ProfileScreen
          setScreen={setScreen}
          onClose={onClickMenuOption}
          onBack={onBack}
        />
      );
    }

    if (currentPage === "myResources") {
      return <MyResources onClose={onClickMenuOption} onBack={onBack} />;
    }

    return (
      <NewMenu onClickMenuOption={onClickMenuOption} setScreen={setScreen} />
    );
  };

  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Drawer
        data-testid="drawer-menu"
        classes={{
          paper: classes.drawerPaper,
        }}
        variant={!smDown || mobileOpen ? "permanent" : "temporary"}
        open={mobileOpen}
      >
        <LinkKeepUTM to="/participant/dashboard">
          <div className={classes.logoContainer}>
            <FruitionLogo className={classes.icon} />
          </div>
        </LinkKeepUTM>
        {renderScreen()}
      </Drawer>
    </nav>
  );
};
